/**
 * Transformer that sums the number of all persons (adults and kids) together.
 */
export default (kasko) => {
  kasko.addEventListener('form-changed', ({ current, previous }) => {
    const state = kasko.getState();

    if (state.route.state.url !== '/start' && state.route.state.url !== '/summary') {
      return;
    }

    if (
      current &&
      previous &&
      current.adults === previous.adults &&
      current.kids === previous.kids
    ) {
      return;
    }

    if (!current.adults || !current.kids) {
      return;
    }

    kasko.dispatchEvent('set-state-input', {
      persons_human: +current.adults.replace('_', '.') + +current.kids.replace('_', '.'),
    });
    kasko.dispatchEvent('set-form-input', {
      persons_human: +current.adults.replace('_', '.') + +current.kids.replace('_', '.'),
    });
  });
};
